
import { Component, mixins, namespace } from 'nuxt-property-decorator';
import { FormState, FormType, PageDto } from 'fourwaves-shared';
import { TranslateResult } from 'vue-i18n';
import Form from 'fourwaves-shared/src/components/Form.vue';
import FormPageMixin from '~/components/layout/FormPageMixin';
import PageHeader from '~/components/layout/PageHeader.vue';
import Summary from '~/components/shared/form/Summary.vue';
import ConfirmationPanel from '~/components/shared/form/ConfirmationPanel.vue';
import Breadcrumb from '~/components/shared/form/Breadcrumb.vue';

const EventsModule = namespace('events');

@Component({
  scrollToTop: true,
  components: {
    PageHeader,
    Form,
    Summary,
    ConfirmationPanel,
    Breadcrumb,
  },
})
export default class RegistrationMain extends mixins(FormPageMixin) {
  @EventsModule.Getter registrationPage!: PageDto | undefined;

  readonly FormState = FormState;
  type: FormType = FormType.Registration;

  get headerTitle(): TranslateResult | string | null {
    if (!this.registrationPage) return null;

    return this.form.state === FormState.FullWithWaitingList
      ? this.$t('registration.waitlist')
      : this.transl8(this.registrationPage.name);
  }

  get headerDescription(): string | null {
    if (this.form.state === FormState.FullWithWaitingList) {
      return `${this.$t('registration.state_FullWithWaitingList')}`;
    }
    if (this.form.state === FormState.PeriodDidNotStart) {
      return `${this.$t('registration.subtitle_not_started')} ${this.showUserFriendlyDate(
        this.currentEvent.registrationStartDate,
      )}`;
    } else if (this.form.state === FormState.PeriodHasEnded) {
      return `${this.$t('registration.subtitle_closed')} ${this.showUserFriendlyDate(
        this.currentEvent.registrationEndDate,
      )}`;
    } else {
      return `${this.$t('registration.subtitle')} ${this.showUserFriendlyDate(this.currentEvent.registrationEndDate)}`;
    }
  }

  get registrationEndedText(): TranslateResult {
    if (this.form.state === FormState.PeriodDidNotStart) {
      return `${this.$t('registration.registration_closed.not_started')} ${this.showUserFriendlyDate(
        this.currentEvent.registrationStartDate,
      )}.`;
    } else if (this.$auth.loggedIn) {
      return this.$t('registration.registration_closed.logged_in_text', { url: this.myRegistrationsUrl });
    } else {
      const url = this.getLoginUrl('', this.myRegistrationsUrl);
      return this.$t('registration.registration_closed.logged_out_text', { url });
    }
  }

  get myRegistrationsUrl(): string {
    return `${this.$config.API_URL}/event-redirect/registrations`;
  }
}
